<template>
  <div class="modal fade" id="informationModal" tabindex="-1" role="dialog" aria-labelledby="informationModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="informationModalLabel">{{titleCard}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          {{contentCard}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrazilModalCard',
  props: {
    titleCard: String,
    contentCard: String,
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ActionMap/BrazilModalCard.vue